import { gql } from 'apollo-angular';

export const RESEND_SMART_STATEMENT_MUTATION_COLLECTIONS_V1 = gql`
  mutation ResendSmartStatementEmailCollectionsV1($actionDefInstanceId: Int!, $recipients: [String!]!) {
    ResendSmartStatementEmailCollectionsV1(
      resendSmartStatementEmailCollectionsV1Request: { actionDefInstanceId: $actionDefInstanceId, recipients: $recipients }
    ) {
      response
    }
  }
`;

export const RESEND_SMART_STATEMENT_MUTATION = gql`
  mutation ResendSmartStatementEmailRequest($id: Int!, $recipients: [String!]!) {
    ResendSmartStatementEmailRequest(resendSmartStatementEmailRequest: { id: $id, recipients: $recipients }) {
      response
    }
  }
`;

export const RESEND_EMAIL_MUTATION = gql`
  mutation ResendEmail($resendEmailRequest: ResendEmailRequest!) {
    ResendEmailRequest(resendEmailRequest: $resendEmailRequest) {
      response
    }
  }
`;
